import { CircularProgress, Grid, Paper } from "@material-ui/core";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import React, { memo, useEffect, useRef } from "react";
import LightGallery from "lightgallery/react";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import lgFullscreen from "lightgallery/plugins/fullscreen";
import lgRotate from "lightgallery/plugins/rotate";
import { SENSITIVE_PLACEHOLDER_IMAGE } from "app/common/LocalConst";
import { ImageLoader } from "./TreamentImagePatient";

const ImageAdviceTabIndex = () => {
  const {
    getListPatientAdviceItem,
    listPatientAdviceItem,
    fetchImage,
    getImageUrl,
    isLoading,
  } = useStore().treatmentManagementStore.treamentInfoPatientStore;

  const { initialPatient } =
    useStore().patientManagementStore.patientGeneralStore;

  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");

  useEffect(() => {
    if (patientId) {
      getListPatientAdviceItem({
        patientId,
        patientCode: initialPatient?.patientInfo?.code,
      });
    }
  }, [patientId]);

  if (isLoading) {
    return (
      <div className="text-center p-5">
        <CircularProgress size={40} />
      </div>
    );
  }

  return (
    <div className="mx-1">
      <Paper elevation={1} style={{ padding: "10px", borderRadius: "6px", border: "1px solid #f0f0f0", background: "#fff" }}>
        <div style={{ fontWeight: "600", marginBottom: "8px", fontSize: "13px", borderBottom: "1px dashed #eee", paddingBottom: "6px" }}>
          Ảnh tư vấn
        </div>
        {listPatientAdviceItem && listPatientAdviceItem.length > 0 ? (
          <LightGalleryInstance 
            id="advice-gallery"
            images={listPatientAdviceItem}
            fetchImage={fetchImage}
            getImageUrl={getImageUrl}
            isShowSensitive={false}
          />
        ) : (
          <div className="text-center p-4 text-gray-400">Không có ảnh tư vấn</div>
        )}
      </Paper>
    </div>
  );
};

// Reuse the refined instance logic
const LightGalleryInstance = observer(({ images, fetchImage, getImageUrl, isShowSensitive }) => {
  const lgRef = useRef(null);
  const onInit = (detail) => { lgRef.current = detail.instance; };

  const { imageUrls } = useStore().treatmentManagementStore.treamentInfoPatientStore;

  const isAllProcessed = images.every(item => {
    const fileId = item.fileId || item.fileDescription?.id;
    return isShowSensitive || !!imageUrls[fileId];
  });

  useEffect(() => {
    if (lgRef.current && isAllProcessed) {
      const timeout = setTimeout(() => {
        lgRef.current.refresh();
      }, 50);
      return () => clearTimeout(timeout);
    }
  }, [isAllProcessed, images.length]);

  const GalleryContent = (
    <>
      {images.map((item) => {
        const fileId = item.fileId || item.fileDescription?.id;
        const blobUrl = getImageUrl(fileId);
        const finalSrc = isShowSensitive ? SENSITIVE_PLACEHOLDER_IMAGE : (blobUrl || "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7");
        
        return (
          <div 
            key={item.id} 
            data-src={finalSrc}
            data-thumb={finalSrc}
            className="lightgallery-item"
            onMouseEnter={() => !blobUrl && !isShowSensitive && fetchImage(fileId)}
            style={{ 
              width: "120px", 
              height: "120px", 
              display: "inline-block", 
              margin: "2px", 
              cursor: isAllProcessed ? "pointer" : "wait",
              opacity: isAllProcessed ? 1 : 0.7
            }}
          >
            <ImageLoader 
              fileId={fileId}
              fetchImage={fetchImage} 
              getImageUrl={getImageUrl} 
              isShowSensitive={isShowSensitive} 
            />
          </div>
        );
      })}
    </>
  );

  if (!isAllProcessed) {
    return (
      <div style={{ position: "relative", pointerEvents: "none", minHeight: "120px" }}>
        {GalleryContent}
        <div style={{
          position: "absolute",
          top: 0, left: 0, right: 0, bottom: 0,
          background: "rgba(255,255,255,0.4)",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: "12px", color: "#888", fontWeight: "bold",
          zIndex: 10
        }}>
          ...
        </div>
      </div>
    );
  }

  return (
    <LightGallery 
      onInit={onInit}
      selector=".lightgallery-item"
      plugins={[lgThumbnail, lgZoom, lgFullscreen, lgRotate]} 
      mode="lg-fade"
    >
      {GalleryContent}
    </LightGallery>
  );
});

export default memo(observer(ImageAdviceTabIndex));
